import React from 'react';
function Minimize({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.444 4v2.667a1.778 1.778 0 01-1.777 1.777H4m16 0h-2.667a1.778 1.778 0 01-1.777-1.777V4m0 16v-2.667a1.778 1.778 0 011.777-1.777H20m-16 0h2.667a1.778 1.778 0 011.777 1.777V20"
      />
    </svg>
  );
}

export default Minimize;
